module.exports = __webpack_public_path__ + "static/media/garage.16829964.svg";